/* eslint-disable react-hooks/rules-of-hooks */
import React from "react";
import { Trans } from "@lingui/macro";
import { useMediaQuery } from "beautiful-react-hooks";
import Button from "../../../components/Button";
import { StepProgress } from "../StepProgress";
import "./DesktopControls.css";
import { isSSR } from "../../../components/NoSSR";

export function DesktopControls({
  onClickPrev,
  onClickNext,
  step,
  stepsTotal,
  disableNext,
  disablePrev,
}) {
  const isMobile = !isSSR && useMediaQuery("(max-width: 767px)");

  return (
    <div className="desktop-controls">
      {!isMobile && <StepProgress value={step} maxValue={stepsTotal} />}

      <div className="desktop-controls__buttons">
        <Button theme="card" size="M" disabled={disablePrev} onClick={onClickPrev}>
          <Trans>Back</Trans>
        </Button>

        <Button
          className="Button--card"
          theme="black"
          size="M"
          disabled={disableNext}
          onClick={onClickNext}
        >
          {step === 2 ? <Trans>Generate</Trans> : <Trans>Next</Trans>}
        </Button>
      </div>
    </div>
  );
}
